<template>
  <v-sheet class="px-6 py-10 fill-height overflow-y-auto py-6 d-flex flex-column align-center">
    <h5 class="text-h5 mb-4 d-flex align-center justify-center mt-8">
      Shop from whatsapp
    </h5>
    <img
      src="https://cc-website.netlify.app/img/chatbot-buy.193c4c17.gif" alt="whatsapp chat in phone"
      class="my-8" style="width: 50%;"
    >
    <v-subheader class="text-center mb-5">
      <div>
        Get in touch with <span class="font-weight-bold">{{ merchant.name }}</span> on whatsapp, click the button
        below to continue
      </div>
    </v-subheader>
    <div class="mt-5 d-flex flex-column align-center">
      <v-btn href="https://wa.me/+2347018082700?text=Hi" class="mt-2" color="green" dark elevation="0" target="_blank">
        Chat with merchant
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'Whatsapp',
  data() {
    return {
      merchant: this.$store.state.merchant,
    }
  }
}
</script>
